import React, { FC, useCallback, useEffect, useState, useContext } from 'react';
import { TasksContext, TasksDispatchContext, TasksProvider, useTask } from '../stateManagement/context';
import { ComponentTypeID, IControlMeasure, IDataGap, IInvestigation, IInvestigationAssessment } from "../types/types";
import { get, post } from "../fetchers/fetchers";
import { getInvestigationAssessment, getInvestigations } from "../stateManagement/data";
import { get_query } from '../stateManagement/data';

import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    IconButton,
    MenuItem,
    Select,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Typography
} from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";
import DialogContentText from "@material-ui/core/DialogContentText";
import { useParams } from "react-router";
import { Delete, Edit, LinkOff } from "@material-ui/icons";
import AddInvestigationDialog from "./add_investigation_dialog";

import { API_URL } from "../env";
interface InvestigationsProps {

}

interface IRouteParams {
    id: string
}



const Investigations: FC<InvestigationsProps> = ({ }) => {
    const [write_access, setWriteAccess] = useState<boolean>(false);

    const [openCreateDialog, setOpenCreateDialog] = useState<boolean>(false);
    const [areYouSure, setAreYouSure] = useState<boolean>(false);
    const [areYouSureInvLinK, setAreYouSureInvLink] = useState<boolean>(false);
    const [openEditDialog, setOpenEditDialog] = useState<boolean>(false);
    const [openAddInvestigationDialog, setAddInvestigationDialog] = useState<boolean>(false);
    const [dataGaps, setDataGaps] = useState<IDataGap[]>([])
    const [investigationAssessments, setInvestigationAssessments] = useState<IInvestigationAssessment[]>([])
    const [controlMeasures, setControlMeasures] = useState<IControlMeasure[]>([]);

    const params = useParams<IRouteParams>()

    const [investigations, setInvestigations] = useState<IInvestigation[]>([])
    const [currentInvestigation, setCurrentInvestigation] = useState<IInvestigation>();
    const [currentInvestigationAssessment, setCurrentInvestigationAssessment] = useState<IInvestigationAssessment>();
    const [currentType, setCurrentType] = useState<ComponentTypeID>();

    const [isLoaded, setIsLoaded] = useState<boolean>(true);
    const [isLoading, setIsLoading] = useState<boolean>(false);

    let dispatch = useContext(TasksDispatchContext)
    let tasks = useTask()

    useEffect(() => {

        if (tasks.loaded) {

            setDataGaps(tasks.dataGaps)
            setControlMeasures(tasks.controlMeasures)
            setInvestigations(tasks.investigations)
            setInvestigationAssessments(tasks.investigationAssessments)
        }

    },[tasks])

    useEffect(() => {
        setWriteAccess(tasks.write_access)
    },[tasks])



    const handleDelete = () => {
        setAreYouSure(false)
        if (!currentInvestigation)
            return
        let ra = { ...currentInvestigation }
        ra.is_active = false
        updateInvestigation(ra)

    }

    const handleDeleteInvLink = () => {
        setAreYouSureInvLink(false)
        if (!currentInvestigationAssessment)
            return
        let ra = { ...currentInvestigationAssessment }
        ra.is_active = false
        removeInvestigationAssessment(ra)

    }


    const handleClose = () => {
        setOpenCreateDialog(false)
    }

    const handleCloseEdit = () => {
        setOpenEditDialog(false)
    }

    const handleOpen = () => {
        setOpenCreateDialog(true)
    }

    const updateInvestigation = (i: IInvestigation) => {
        delete i.document
        delete i.id
        delete i.group
        postInvestigation(i).then(() => {
            setIsLoaded(false)
        })
    }
    const postInvestigation = async (f: IInvestigation) => {
        // check if states in params
        let query_params = get_query()

        // check if state key in params
        if (query_params.state) {
            f["state_id"] = parseInt(query_params.state)
        }
        

        await post<IInvestigation>(API_URL + "investigations/" + + params.id + "/", f);
        await getInvestigations(params.id, dispatch)
    }

    const postInvestigationAssessment = async (f: IInvestigationAssessment) => {

        // check if states in params
        let query_params = get_query()

        // check if state key in params
        if (query_params.state) {
            f["state_id"] = parseInt(query_params.state)
        }
        
        await post<IInvestigationAssessment>(API_URL + "investigations/" + + params.id + "/investigation_assessment", f);
        await getInvestigationAssessment(params.id, dispatch)

    }

    const updateInvestigationAssessment = () => {
        handleCloseAddInvestigation()
        if (!currentInvestigationAssessment) {
            throw new Error("currentInvestigationAssessment needs to be set")
        }

        let i = { ...currentInvestigationAssessment }
        delete i.id
        postInvestigationAssessment(i).then(() => {
            setIsLoaded(false)
        })
    }

    const removeInvestigationAssessment = (inv: IInvestigationAssessment) => {
        if (!inv) {
            throw new Error("currentInvestigationAssessment needs to be set")
        }

        let i = { ...inv }
        delete i.id
        postInvestigationAssessment(i).then(() => {
            setIsLoaded(false)
        })
    }

    const renderAreYouSure = () => {
        return (
            <Dialog open={areYouSure} onClose={handleAreaYouSure} aria-labelledby="form-dialog-title">
                <DialogTitle id="form-dialog-title">Remove  {currentInvestigation?.name}</DialogTitle>

                <DialogContent>
                    <DialogContentText>
                        <Typography>
                            Are you sure you want to remove investigation <b>{currentInvestigation?.name}</b>
                        </Typography>
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleAreaYouSure} color="primary">
                        Cancel
                    </Button>
                    <Button onClick={handleDelete} color="primary">
                        Confirm
                    </Button>
                </DialogActions>
            </Dialog>
        )
    }

    const renderAreYouSureInvLink = () => {
        let name = ""
        if (currentType == ComponentTypeID.SummaryOfKnowledge) {
            name += dataGaps.find((dg) => dg.uuid == currentInvestigationAssessment?.assessment_uuid)?.name || ""

        }

        if (currentType == ComponentTypeID.AdditionalControlMeasuer) {
            name += controlMeasures.find((dg) => dg.uuid == currentInvestigationAssessment?.assessment_uuid)?.description || ""
        }

        return (
            <Dialog open={areYouSureInvLinK} onClose={handleAreaYouSureInvLink} aria-labelledby="form-dialog-title">
                <DialogTitle id="form-dialog-title">Remove  {currentInvestigation?.name}</DialogTitle>

                <DialogContent>
                    <DialogContentText>
                        <Typography>
                            Are you sure you want to remove link <b>{name}</b> - <b>{currentInvestigation?.name}</b>
                        </Typography>
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleAreaYouSureInvLink} color="primary">
                        Cancel
                    </Button>
                    <Button onClick={handleDeleteInvLink} color="primary">
                        Confirm
                    </Button>
                </DialogActions>
            </Dialog>
        )
    }


    const handleAreaYouSure = () => {
        setAreYouSure(false)
    }

    const handleAreaYouSureInvLink = () => {
        setAreYouSureInvLink(false)
    }

    const handleCloseAddInvestigation = () => {
        setAddInvestigationDialog(false)
    }

    const handleAddInvestigation = (investigation: IInvestigation, type: ComponentTypeID) => {
        setCurrentInvestigation(investigation)
        setCurrentType(type)
        setAddInvestigationDialog(true)
    }

    const addButton = (investigation: IInvestigation, type: ComponentTypeID) => {
        return (
            <Button color="secondary" component="span"
                style={{
                    color: "rgb(239,88,43)"
                }} onClick={() => handleAddInvestigation(investigation, type)}>
                link
            </Button>)

    }

    const renderLinkAssessment = () => {
        if (!openAddInvestigationDialog) {
            return <></>
        }
        if (!currentInvestigation) {
            throw new Error("currentInvestigation needs to be set")
        }
        if (!currentType) {
            throw new Error("currentType needs to be set")
        }
        return (
            <Dialog open={openAddInvestigationDialog} onClose={handleCloseAddInvestigation} aria-labelledby="form-dialog-title">
                <DialogTitle id="form-dialog-title">Add {currentInvestigation.name}</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        <Typography>
                            <Select
                                style={{ fontSize: "11pt" }}
                                onChange={(event) => {
                                    let value = parseInt(event.target.value as string)
                                    if (value) {
                                        let c = {
                                            investigation_uuid: currentInvestigation?.uuid,
                                            assessment_uuid: value,
                                            link_type: currentType,
                                            is_active: true
                                        }
                                        setCurrentInvestigationAssessment(c)

                                    }
                                }}>
                                {currentType == ComponentTypeID.SummaryOfKnowledge && dataGaps.map((d) => {
                                    return <MenuItem value={d.uuid}>{d.name}</MenuItem>
                                })}
                                {currentType == ComponentTypeID.AdditionalControlMeasuer && controlMeasures.map((d) => {
                                    return <MenuItem value={d.uuid}>{d.description}</MenuItem>
                                })}
                            </Select>
                        </Typography>
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseAddInvestigation} color="primary">
                        Cancel
                    </Button>
                    <Button onClick={updateInvestigationAssessment} color="primary">
                        Confirm
                    </Button>
                </DialogActions>
            </Dialog>
        )
    }

    const renderInvestigationAssessment = (investigation: IInvestigation, type: ComponentTypeID) => {

        let ias = investigationAssessments.filter(
            (ia) => ia.investigation_uuid == investigation.uuid && ia.link_type == type)
        if (ias.length === 0) {
            return <>-</>
        }

        return ias.map((ia, index) => {
            let name = ""
            if (index > 0) {
                name = ", "
            }
            if (type == ComponentTypeID.SummaryOfKnowledge) {
                name += dataGaps.find((dg) => dg.uuid == ia.assessment_uuid)?.name || ""

            }

            if (type == ComponentTypeID.AdditionalControlMeasuer) {
                name += controlMeasures.find((dg) => dg.uuid == ia.assessment_uuid)?.description || ""
            }
            return <>

                {name}

                {write_access && <IconButton color="primary" aria-label="upload picture" component="span" style={{
                    color: "rgb(239,88,43)",

                }} onClick={() => {
                    //setCurrentDataGap(dataGap)

                    setCurrentInvestigation(investigation)
                    setAreYouSureInvLink(true)
                    setCurrentType(type)
                    setCurrentInvestigationAssessment(ia)

                }} >
                    <LinkOff />
                </IconButton>}

            </>
        }
        )

    }
    const renderInvestigation = (index: number, investigation: IInvestigation) => {
        return (
            <TableRow>
                <TableCell>{investigation.name}</TableCell>
                <TableCell>{investigation.cost}</TableCell>
                <TableCell>{investigation.timeframe}</TableCell>
                <TableCell> {write_access && addButton(investigation, ComponentTypeID.SummaryOfKnowledge)}
                    {renderInvestigationAssessment(investigation, ComponentTypeID.SummaryOfKnowledge)}</TableCell>
                <TableCell> {write_access && addButton(investigation, ComponentTypeID.AdditionalControlMeasuer)}
                    {renderInvestigationAssessment(investigation, ComponentTypeID.AdditionalControlMeasuer)}</TableCell>
                <TableCell>
                    {write_access &&
                    <>
                    <IconButton color="primary" aria-label="upload picture" component="span" style={{
                        color: "rgb(239,88,43)",

                    }} onClick={() => {
                        setCurrentInvestigation(investigation)
                        setOpenEditDialog(true)
                    }}>
                        <Edit />
                    </IconButton>

                    <IconButton color="primary" aria-label="upload picture" component="span" style={{
                        color: "rgb(239,88,43)",

                    }} onClick={() => {
                        setCurrentInvestigation(investigation)
                        setAreYouSure(true)

                    }} >
                        <Delete />
                    </IconButton>
                    </> }
                </TableCell>

            </TableRow>
        )
    }

    return (
        <>

            {renderAreYouSure()}
            {renderAreYouSureInvLink()}
            {renderLinkAssessment()}


            {openCreateDialog && <AddInvestigationDialog investigation={{
                uuid: -1, is_active: true
            }} updateInvestigation={updateInvestigation} closeDialogCallback={handleClose} />}

            {(openEditDialog && currentInvestigation) && <AddInvestigationDialog investigation={currentInvestigation} updateInvestigation={updateInvestigation} closeDialogCallback={handleCloseEdit} />}

            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell>Investigation</TableCell>
                        <TableCell>Cost</TableCell>
                        <TableCell>Timeframe (months)</TableCell>
                        <TableCell>Data Gap</TableCell>
                        <TableCell>Additional Control Measure</TableCell>
                        <TableCell>Controls</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    <TableRow>
                        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6} align={"center"}>
                            {write_access && <IconButton color="primary" component="span"
                                style={{
                                    margin: "auto",
                                    backgroundColor: "rgb(239,88,43)",
                                    color: "rgb(255,255,255)"
                                }} onClick={() => handleOpen()}>
                                <AddIcon fontSize="small" />
                            </IconButton>}
                        </TableCell>
                    </TableRow>
                    {investigations.map((f, index) => {
                        return renderInvestigation(index, f)
                    })}
                </TableBody>
            </Table>
        </>
    );
}

export default Investigations;

